import React from "react";
import { RiLogoutCircleRLine } from "react-icons/ri";
import "../../features/dashboard/screens/AdminDashboard.css";
import { BsJustify } from "react-icons/bs";
import { IoArrowBack } from "react-icons/io5";
import { useAdminAuth } from "../../features/auth/AdminAuthProvider";
import { useNavigate, useLocation } from "react-router-dom";

const DashboardHeader = () => {
  const { adminLogout, toggleSidebar } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboard = location.pathname.toLowerCase() === "/dashboard";

  const handleLogoutClick = () => {
    adminLogout();
    navigate("/");
  };

  return (
    <nav className="dashboard-header-nav">
      <div className="header-inner-container">
        <div className="header-left-section">
          <div className="menu-tab" onClick={toggleSidebar}>
            <BsJustify className="header-icon" />
          </div>

          <div
            className="header-back-action"
            title="Go Back"
            onClick={() => {
              if (isDashboard) {
                navigate("/dashboard");
              } else {
                navigate(-1);
              }
            }}
          >
            <span className="header-back-text">Back</span>
          </div>
        </div>

        <div className="header-center-section">
          <span className="brand-text">VETRI VIKAS CAPITAL TRUST</span>
        </div>

        <div className="header-right-section">
          <button
            className="btn-header-logout"
            title="Logout"
            onClick={handleLogoutClick}
          >
            <RiLogoutCircleRLine />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default DashboardHeader;
